import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function adaptFilterType(type) {
  if (type === "any") return {};
  if (type === "all") return {
    type: "and"
  };
  return {
    type: "and"
  };
}

export function adaptFacetConfig(facets) {
  if (!facets) return;

  var convertInvalidFacetsToUndefined = function convertInvalidFacetsToUndefined(_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        fieldName = _ref2[0],
        config = _ref2[1];

    if (config.type != "value") {
      console.warn("search-ui-site-search-connector: Dropping ".concat(fieldName, " facet, only value facets are supported in Site Search"));
      return;
    }

    if (config.sort) {
      console.warn("search-ui-site-search-connector: Site Search does not support 'sort' on facets");
    }

    if (config.size) {
      console.warn("search-ui-site-search-connector: Site Search does not support 'size' on facets");
    }

    return [fieldName, config];
  };

  var getKey = function getKey(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        key = _ref4[0];

    return key;
  };

  var config = Object.entries(facets).map(convertInvalidFacetsToUndefined).filter(function (v) {
    return v;
  }).map(getKey);
  if (!config.length) return;
  return config;
}
export function adaptFilterConfig(filters) {
  if (!filters || Object.keys(filters).length === 0) return;
  return filters.reduce(function (acc, filter) {
    var fieldName = filter.field;
    var fieldValue = filter.values;

    if (acc[fieldName]) {
      console.warn("search-ui-site-search-connector: More than one filter found for a single field");
      return acc;
    }

    if (filter.type && filter.type !== "all" && filter.type !== "any") {
      console.warn("search-ui-site-search-connector: Unsupported filter type \"".concat(filter.type, "\" found, only \"all\" and \"any\" are currently supported"));
      return acc;
    }

    if (fieldValue.find(function (v) {
      return _typeof(v) === "object";
    }) !== undefined) {
      if (fieldValue.length > 1) {
        console.warn("search-ui-site-search-connector: Cannot apply more than 1 none-value filters to a single field");
        return acc;
      }

      var firstValue = fieldValue[0];

      if (firstValue.from || firstValue.from === 0 || firstValue.to || firstValue.to === 0) {
        // eslint-disable-next-line
        var name = firstValue.name,
            rest = _objectWithoutProperties(firstValue, ["name"]);

        acc[fieldName] = _objectSpread({
          type: "range"
        }, rest);
        return acc;
      } else {
        return acc;
      }
    }

    acc[fieldName] = _objectSpread(_objectSpread({}, adaptFilterType(filter.type)), {}, {
      values: fieldValue
    });
    return acc;
  }, {});
}
export function adaptResultFieldsConfig(resultFieldsConfig) {
  if (!resultFieldsConfig) return [];
  var fetchFields = Object.keys(resultFieldsConfig);
  var highlightFields = Object.entries(resultFieldsConfig).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        fieldName = _ref6[0],
        fieldConfig = _ref6[1];

    if (!fieldConfig.snippet) return acc;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, fieldName, fieldConfig.snippet));
  }, {});
  return [fetchFields, highlightFields];
}
export function adaptSearchFieldsConfig(searchFieldsConfig) {
  if (!searchFieldsConfig) return [];
  return Object.keys(searchFieldsConfig);
}